import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Groups Redux States
import { GET_GROUPS, GET_GROUP } from "./actionTypes";
import { loadGroups, apiError, setGroup } from "./actions";
//Include Both Helper File with needed methods
import axios from "axios";

function* getGroups({ payload: { idCompany, page, qnt } }) {
  //TODO: get client_id from company
  try {
    const response = yield call(
      axios.get,
      `/group${
        idCompany
          ? `?client_id=${idCompany}
          ${page && qnt ? `&page=${page}&qnt=${qnt}` : ""}`
          : ""
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(loadGroups(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 400:
          message = "Invalid data";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* getGroup({ payload: { clientId, idGroup } }) {
  try {
    const response = yield call(
      axios.get,
      `/group${
        clientId && idGroup ? `?client_id=${clientId}&id=${idGroup}` : ""
      }`,
      {}
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setGroup(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 400:
          message = "Invalid data";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
export function* watchGroup() {
  yield takeEvery(GET_GROUPS, getGroups);
}
export function* watchGetGroup() {
  yield takeEvery(GET_GROUP, getGroup);
}
function* authSaga() {
  yield all([fork(watchGroup), fork(watchGetGroup)]);
}

export default authSaga;
